var fee_frequencies = {
  fee_frequencies: {
    free: {
    id: "1",
    txt_id: "free",
    name: "Included"
    },
    monthly: {
    id: "2",
    txt_id: "monthly",
    name: "Paid Monthly"
    },
    one_time: {
    id: "3",
    txt_id: "one_time",
    name: "One-Time Payment"
    },
    weekly: {
    id: "4",
    txt_id: "weekly",
    name: "Paid Weekly"
    },
    not_available: {
    id: "5",
    txt_id: "not_available",
    name: "Not Available"
    }
  }
}

module.exports = fee_frequencies
